import "../node_modules/flag-icons/css/flag-icons.min.css"; //for flags
import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GoogleLoginCallback from './auth/googleLoginCallback';
import Login from './auth/login.js';
import Signup from './auth/signup';
import { Dashboard } from "./containers/Dashboard";
import { generateRandomString } from './helpers/generateRandomString';
import RedirectUrl from './helpers/redirectUrl';
import HomePage from "./website/homePage";
import Terms from './website/terms';
// import SpotifyHome from './dashboard/spotify/spotifyHome'
import ForgotPassword from './auth/forgotPassword';
import ResetPassword from './auth/resetPassword';
import StripeCallback from './callback/stripeCallback';
import config from './config';
import AmazonMusicCallback from './dashboard/amazonMusic/amazonMusicCallback';
import SpotifyCallback from './dashboard/spotify/spotifyCallback';
import TidalCallback from './dashboard/tidal/tidalCallback';
import YouTubeCallback from './dashboard/youtube/youtubeCallback';
import YoutubeMusicCallback from './dashboard/youtube/youtubeMusicCallback';
import EmailHandler from './email/emailHandler';
import RedirectTidal from './helpers/redirectTidal';
import "./i18n/i18n.js";
import Contact from "./website/contact/index.js";
import Sync from "./website/pages/sync.js";
import Transfer from "./website/pages/transfer.js";
import NotFound from './components/notFound'
import BlogMain from "./website/blog/index.js";
import BlogPage from "./website/blog/blogPage.js";
import { FAQPage } from "./containers/FAQPage.tsx";
import Layout from "./components/Layout";

// Guides
import SpotifyGuide from "./containers/Guides/SpotifyGuide";
import AppleMusicGuide from "./containers/Guides/AppleMusicGuide";
import YoutubeMusicGuide from "./containers/Guides/YoutubeMusicGuide";
import YoutubeGuide from "./containers/Guides/YoutubeGuide";
import TidalGuide from "./containers/Guides/TidalGuide";

// Transfer Guides
import TransferAppleMusicToSpotify from "./containers/Guides/transfer/apple-music/toSpotify";
import TransferSpotifyToAppleMusic from "./containers/Guides/transfer/spotify/toAppleMusic";
import TransferSpotifyToYoutubeMusic from "./containers/Guides/transfer/spotify/toYoutubeMusic";
import TransferSpotifyToYoutube from "./containers/Guides/transfer/spotify/toYoutube";
import TransferSpotifyToSpotify from "./containers/Guides/transfer/spotify/toSpotify";
import TransferAppleMusicToYoutubeMusic from "./containers/Guides/transfer/apple-music/toYoutubeMusic";
import TransferAppleMusicToYoutube from "./containers/Guides/transfer/apple-music/toYoutube";
import TransferAppleMusicToAppleMusic from "./containers/Guides/transfer/apple-music/toAppleMusic";
import TransferYoutubeMusicToSpotify from "./containers/Guides/transfer/youtube-music/toSpotify";
import TransferYoutubeMusicToAppleMusic from "./containers/Guides/transfer/youtube-music/toAppleMusic";
import TransferYoutubeMusicToYoutube from "./containers/Guides/transfer/youtube-music/toYoutube";
import TransferYoutubeMusicToYoutubeMusic from "./containers/Guides/transfer/youtube-music/toYoutubeMusic";
import TransferYoutubeToSpotify from "./containers/Guides/transfer/youtube/toSpotify";
import TransferYoutubeToAppleMusic from "./containers/Guides/transfer/youtube/toAppleMusic";
import TransferYoutubeToYoutubeMusic from "./containers/Guides/transfer/youtube/toYoutubeMusic";
import TransferYoutubeToYoutube from "./containers/Guides/transfer/youtube/toYoutube";
import TransferSpotifyToTidal from "./containers/Guides/transfer/spotify/toTidal";
import TransferAppleMusicToTidal from "./containers/Guides/transfer/apple-music/toTidal";
import TransferYoutubeMusicToTidal from "./containers/Guides/transfer/youtube-music/toTidal";
import TransferYoutubeToTidal from "./containers/Guides/transfer/youtube/toTidal";
import TransferTidalToSpotify from "./containers/Guides/transfer/tidal/toSpotify";
import TransferTidalToAppleMusic from "./containers/Guides/transfer/tidal/toAppleMusic";
import TransferTidalToYoutubeMusic from "./containers/Guides/transfer/tidal/toYoutubeMusic";
import TransferTidalToYoutube from "./containers/Guides/transfer/tidal/toYoutube";
import TransferTidalToTidal from "./containers/Guides/transfer/tidal/toTidal";

// Sync Guides
import SyncSpotifyToAppleMusic from "./containers/Guides/sync/spotify/toAppleMusic";
import SyncSpotifyToYoutubeMusic from "./containers/Guides/sync/spotify/toYoutubeMusic";
import SyncSpotifyToYoutube from "./containers/Guides/sync/spotify/toYoutube";
import SyncSpotifyToSpotify from "./containers/Guides/sync/spotify/toSpotify";
import SyncAppleMusicToYoutubeMusic from "./containers/Guides/sync/apple-music/toYoutubeMusic";
import SyncAppleMusicToYoutube from "./containers/Guides/sync/apple-music/toYoutube";
import SyncAppleMusicToAppleMusic from "./containers/Guides/sync/apple-music/toAppleMusic";
import SyncAppleMusicToSpotify from "./containers/Guides/sync/apple-music/toSpotify";
import SyncYoutubeMusicToSpotify from "./containers/Guides/sync/youtube-music/toSpotify";
import SyncYoutubeMusicToAppleMusic from "./containers/Guides/sync/youtube-music/toAppleMusic";
import SyncYoutubeMusicToYoutube from "./containers/Guides/sync/youtube-music/toYoutube";
import SyncYoutubeMusicToYoutubeMusic from "./containers/Guides/sync/youtube-music/toYoutubeMusic";
import SyncYoutubeToSpotify from "./containers/Guides/sync/youtube/toSpotify";
import SyncYoutubeToAppleMusic from "./containers/Guides/sync/youtube/toAppleMusic";
import SyncYoutubeToYoutubeMusic from "./containers/Guides/sync/youtube/toYoutubeMusic";
import SyncYoutubeToYoutube from "./containers/Guides/sync/youtube/toYoutube";
import SyncSpotifyToTidal from "./containers/Guides/sync/spotify/toTidal";
import SyncAppleMusicToTidal from "./containers/Guides/sync/apple-music/toTidal";
import SyncYoutubeMusicToTidal from "./containers/Guides/sync/youtube-music/toTidal";
import SyncYoutubeToTidal from "./containers/Guides/sync/youtube/toTidal";
import SyncTidalToSpotify from "./containers/Guides/sync/tidal/toSpotify";
import SyncTidalToAppleMusic from "./containers/Guides/sync/tidal/toAppleMusic";
import SyncTidalToYoutubeMusic from "./containers/Guides/sync/tidal/toYoutubeMusic";
import SyncTidalToYoutube from "./containers/Guides/sync/tidal/toYoutube";
import SyncTidalToTidal from "./containers/Guides/sync/tidal/toTidal";

import ScrollToTop from "./components/ScrollToTop";

function App() {

  const APP_URL = config.appUrl;


  const SPOTIFY_LOGIN_URL = "https://accounts.spotify.com/authorize"
  + "?response_type=code"
  + "&client_id=5bf112fd22d14fac8256db5402961f24"
  + "&scope=playlist-read-private playlist-read-collaborative playlist-modify-private playlist-modify-public user-library-modify user-library-read"
  + "&redirect_uri=" + APP_URL + "/connect/spotify/authenticate"
  + "&state=" + generateRandomString(16)


  const AMAZON_MUSIC_URL = "https://www.amazon.com/ap/oa"
  + "?response_type=code"
  + "&client_id=amzn1.application-oa2-client.024b8f0945da477a83fa0f1a828c8a53"
  + "&scope=profile music::library"
  + "&redirect_uri=" + APP_URL + "/connect/amazonMusic/authenticate"
  + "&state=" + generateRandomString(16)


  const YOUTUBE_LOGIN_URL = "https://accounts.google.com/o/oauth2/v2/auth"
  + "?response_type=code"
  + "&client_id="+config.googleAuthClientId
  + "&scope=https://www.googleapis.com/auth/youtube"
  + "&redirect_uri=" + APP_URL + "/connect/youtube/authenticate"
  + "&state=" + generateRandomString(16)
  +"&access_type=offline"
  +"&prompt=consent"
  

  const YOUTUBE_MUSIC_LOGIN_URL = "https://accounts.google.com/o/oauth2/v2/auth"
  + "?response_type=code"
  + "&client_id="+config.googleAuthClientId
  + "&scope=https://www.googleapis.com/auth/youtube"
  + "&redirect_uri=" + APP_URL + "/connect/youtubeMusic/authenticate"
  + "&state=" + generateRandomString(16)
  +"&access_type=offline"
  +"&prompt=consent"
  


  //TODO: show icloud enable music library


  return (
    <BrowserRouter>
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<HomePage/>}/>
        <Route path='/transfer-playlists-and-songs' element={<Transfer/>}/>
        <Route path='/sync-playlists' element={<Sync/>}/>
        <Route path='/contact-us' element={<Contact/>}/>
        <Route path='/privacy-and-terms' element={<Terms/>}/>


        <Route path='/blog' element={<BlogMain/>}/>
        <Route path='/blog/:slug' element={<BlogPage/>}/>

        <Route path='/spotify' element={<SpotifyGuide/>}/>
        <Route path='/apple-music' element={<AppleMusicGuide/>}/>
        <Route path='/youtube-music' element={<YoutubeMusicGuide/>}/>
        <Route path='/youtube' element={<YoutubeGuide/>}/>
        <Route path='/tidal' element={<TidalGuide/>}/>

        <Route path='/transfer/spotify-to-apple-music' element={<TransferSpotifyToAppleMusic/>}/>
        <Route path='/transfer/spotify-to-youtube-music' element={<TransferSpotifyToYoutubeMusic/>}/>
        <Route path='/transfer/spotify-to-youtube' element={<TransferSpotifyToYoutube/>}/>
        <Route path='/transfer/spotify-to-spotify' element={<TransferSpotifyToSpotify/>}/>

        <Route path='/transfer/apple-music-to-spotify' element={<TransferAppleMusicToSpotify/>}/>
        <Route path='/transfer/apple-music-to-youtube-music' element={<TransferAppleMusicToYoutubeMusic/>}/>
        <Route path='/transfer/apple-music-to-youtube' element={<TransferAppleMusicToYoutube/>}/>
        <Route path='/transfer/apple-music-to-apple-music' element={<TransferAppleMusicToAppleMusic/>}/>

        <Route path='/transfer/youtube-music-to-spotify' element={<TransferYoutubeMusicToSpotify/>}/>
        <Route path='/transfer/youtube-music-to-apple-music' element={<TransferYoutubeMusicToAppleMusic/>}/>
        <Route path='/transfer/youtube-music-to-youtube' element={<TransferYoutubeMusicToYoutube/>}/>
        <Route path='/transfer/youtube-music-to-youtube-music' element={<TransferYoutubeMusicToYoutubeMusic/>}/>

        <Route path='/transfer/youtube-to-spotify' element={<TransferYoutubeToSpotify/>}/>
        <Route path='/transfer/youtube-to-apple-music' element={<TransferYoutubeToAppleMusic/>}/>
        <Route path='/transfer/youtube-to-youtube-music' element={<TransferYoutubeToYoutubeMusic/>}/>
        <Route path='/transfer/youtube-to-youtube' element={<TransferYoutubeToYoutube/>}/>
        <Route path='/transfer/spotify-to-tidal' element={<TransferSpotifyToTidal/>}/>
        <Route path='/transfer/apple-music-to-tidal' element={<TransferAppleMusicToTidal/>}/>
        <Route path='/transfer/youtube-music-to-tidal' element={<TransferYoutubeMusicToTidal/>}/>
        <Route path='/transfer/youtube-to-tidal' element={<TransferYoutubeToTidal/>}/>
        <Route path='/transfer/tidal-to-spotify' element={<TransferTidalToSpotify/>}/>
        <Route path='/transfer/tidal-to-apple-music' element={<TransferTidalToAppleMusic/>}/>
        <Route path='/transfer/tidal-to-youtube-music' element={<TransferTidalToYoutubeMusic/>}/>
        <Route path='/transfer/tidal-to-youtube' element={<TransferTidalToYoutube/>}/>
        <Route path='/transfer/tidal-to-tidal' element={<TransferTidalToTidal/>}/>

        <Route path='/sync/spotify-to-apple-music' element={<SyncSpotifyToAppleMusic/>}/>
        <Route path='/sync/spotify-to-youtube-music' element={<SyncSpotifyToYoutubeMusic/>}/>
        <Route path='/sync/spotify-to-youtube' element={<SyncSpotifyToYoutube/>}/>
        <Route path='/sync/spotify-to-spotify' element={<SyncSpotifyToSpotify/>}/>

        <Route path='/sync/apple-music-to-spotify' element={<SyncAppleMusicToSpotify/>}/>
        <Route path='/sync/apple-music-to-youtube-music' element={<SyncAppleMusicToYoutubeMusic/>}/>
        <Route path='/sync/apple-music-to-youtube' element={<SyncAppleMusicToYoutube/>}/>
        <Route path='/sync/apple-music-to-apple-music' element={<SyncAppleMusicToAppleMusic/>}/>

        <Route path='/sync/youtube-music-to-spotify' element={<SyncYoutubeMusicToSpotify/>}/>
        <Route path='/sync/youtube-music-to-apple-music' element={<SyncYoutubeMusicToAppleMusic/>}/>
        <Route path='/sync/youtube-music-to-youtube' element={<SyncYoutubeMusicToYoutube/>}/>
        <Route path='/sync/youtube-music-to-youtube-music' element={<SyncYoutubeMusicToYoutubeMusic/>}/>

        <Route path='/sync/youtube-to-spotify' element={<SyncYoutubeToSpotify/>}/>
        <Route path='/sync/youtube-to-apple-music' element={<SyncYoutubeToAppleMusic/>}/>
        <Route path='/sync/youtube-to-youtube-music' element={<SyncYoutubeToYoutubeMusic/>}/>
        <Route path='/sync/youtube-to-youtube' element={<SyncYoutubeToYoutube/>}/>
        <Route path='/sync/spotify-to-tidal' element={<SyncSpotifyToTidal/>}/>
        <Route path='/sync/apple-music-to-tidal' element={<SyncAppleMusicToTidal/>}/>
        <Route path='/sync/youtube-music-to-tidal' element={<SyncYoutubeMusicToTidal/>}/>
        <Route path='/sync/youtube-to-tidal' element={<SyncYoutubeToTidal/>}/>
        <Route path='/sync/tidal-to-spotify' element={<SyncTidalToSpotify/>}/>
        <Route path='/sync/tidal-to-apple-music' element={<SyncTidalToAppleMusic/>}/>
        <Route path='/sync/tidal-to-youtube-music' element={<SyncTidalToYoutubeMusic/>}/>
        <Route path='/sync/tidal-to-youtube' element={<SyncTidalToYoutube/>}/>
        <Route path='/sync/tidal-to-tidal' element={<SyncTidalToTidal/>}/>

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        <Route path='/dashboard/*' element={<Dashboard />} />
        <Route path='/faq' element={<FAQPage />} />
        
        <Route path='/dashboard' element={<RedirectUrl url={"/dashboard/accounts"} />} />
                      
        <Route path='/login/google/authenticate' element={<GoogleLoginCallback/>} />


        <Route path='/connect/spotify' element={<RedirectUrl url={SPOTIFY_LOGIN_URL} />} />
        <Route path='/connect/spotify/authenticate' element={<SpotifyCallback/>} /> 


        <Route path='/connect/tidal' element={<RedirectTidal />} />
        <Route path='/connect/tidal/authenticate' element={<TidalCallback/>} /> 

        <Route path='/connect/amazonMusic' element={<RedirectUrl url={AMAZON_MUSIC_URL} />} />
        <Route path='/connect/amazonMusic/authenticate' element={<AmazonMusicCallback/>} /> 

        <Route path='/email-link/:userId/activateAccount/:token' element={<EmailHandler action="activateAccount" />}/>
        <Route path='/email-link/:userId/updatePassword/:token' element={<EmailHandler action="updatePassword"/>}/>
        <Route path='/email-link/dashboard/transferHistory' element={<RedirectUrl url={config.transferHistoryPath}/>}/>

        <Route path='/forgotPassword' element={<ForgotPassword/>} />
        <Route path='/resetPassword/:userId/:token' element={<ResetPassword/>} />

        <Route path='/connect/youtube' element={<RedirectUrl url={YOUTUBE_LOGIN_URL} />} />
        <Route path='/connect/youtube/authenticate' element={<YouTubeCallback/>} />

        <Route path='/connect/youtubeMusic' element={<RedirectUrl url={YOUTUBE_MUSIC_LOGIN_URL} />} />
          <Route path='/connect/youtubeMusic/authenticate' element={<YoutubeMusicCallback/>} />

        <Route path="/stripe/callback" element={<StripeCallback></StripeCallback>} />
        <Route path="*" element={<NotFound />} status={404} />
      </Routes>
    </Layout>
    </BrowserRouter>
  )
}

export default App;